module.exports = __webpack_public_path__ + "static/opengraph-f8c00c218d5dd57bea7cfbb54c047892.png";